// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Title-Geometry {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px; 
  text-transform: uppercase;
}


ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.checkbox-item {
  display: flex;
  align-items: center;
  padding: 4px 0; 
  margin-bottom: 4px; 
}


.checkbox-item input[type="checkbox"] {
  accent-color: #7490c7;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  cursor: pointer;
}

.checkbox-item label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #555;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}


.modal-content {
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  width: 350px;
  max-width: 90%;
  text-align: center;
  position: relative;
  animation: fadeIn 0.3s ease-in-out;
}


@keyframes fadeIn {
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
}


.modal-content h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}


.modal-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}


.modal-content li {
  background: #f8f9fa;
  padding: 8px;
  margin: 5px 0;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.modal-content input {
  width: 50%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}


.modal-content button {
  margin-top: 15px;
  padding: 10px 15px;
  background: #7490c7;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}


.modal-content button:hover {
  background: #5d78a6; 
  transform: scale(1.05);
}


.modal-content button:active {
  background: #4b6088; 
  transform: scale(0.98);
}


.modal-content button:not(:last-child) {
  margin-right: 10px;
}


@media (max-width: 400px) {
  .modal-content {
      width: 90%;
      padding: 15px;
  }

  .modal-content h3 {
      font-size: 18px;
  }
}

.dropdown-container {
  width: 100%;
  margin: 10px 0;
  position: relative;
  font-size: 0.9rem;
}

.dropdown-header {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  transition: border 0.3s ease;
}

.dropdown-header:hover {
  border-color: #999;
}

.dropdown-header:focus, .dropdown-header:active {
  border-color: #7490c7;
  outline: none;
  box-shadow: 0 0 4px rgba(0, 120, 215, 0.2);
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  top: 110%;
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}




/* new dropdown */

.custom-select-container {
  
  position: relative;
  width: 100%;
  max-width: 220px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.custom-select-header {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}

.custom-select-header:hover {
  border-color: #999;
}

.custom-select-header .arrow {
  margin-left: 10px;
  font-size: 12px;

}

.custom-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 4px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 8px 0;
}

.custom-select-item {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  padding: 6px 12px;
  gap: 8px;
  white-space: normal;
  word-break: break-word;
}

.custom-select-item:hover {
  background-color: #f1f1f1;
}

.custom-select-item input {
  margin-top: 2px;
}




`, "",{"version":3,"sources":["webpack://./src/Components/SideBarSection/GeometrySection/GeometryShape.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;;AAGA;EACE;MACI,UAAU;MACV,4BAA4B;EAChC;EACA;MACI,UAAU;MACV,wBAAwB;EAC5B;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;;AAGA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE;MACI,UAAU;MACV,aAAa;EACjB;;EAEA;MACI,eAAe;EACnB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA,iBAAiB;;AAEjB;;EAEE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n.Title-Geometry {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px; \n  text-transform: uppercase;\n}\n\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.checkbox-item {\n  display: flex;\n  align-items: center;\n  padding: 4px 0; \n  margin-bottom: 4px; \n}\n\n\n.checkbox-item input[type=\"checkbox\"] {\n  accent-color: #7490c7;\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.checkbox-item label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #555;\n}\n\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n\n.modal-content {\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);\n  width: 350px;\n  max-width: 90%;\n  text-align: center;\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n\n@keyframes fadeIn {\n  from {\n      opacity: 0;\n      transform: translateY(-20px);\n  }\n  to {\n      opacity: 1;\n      transform: translateY(0);\n  }\n}\n\n\n.modal-content h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n\n.modal-content ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n\n.modal-content li {\n  background: #f8f9fa;\n  padding: 8px;\n  margin: 5px 0;\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n\n.modal-content input {\n  width: 50%;\n  padding: 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: center;\n}\n\n\n.modal-content button {\n  margin-top: 15px;\n  padding: 10px 15px;\n  background: #7490c7;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n\n.modal-content button:hover {\n  background: #5d78a6; \n  transform: scale(1.05);\n}\n\n\n.modal-content button:active {\n  background: #4b6088; \n  transform: scale(0.98);\n}\n\n\n.modal-content button:not(:last-child) {\n  margin-right: 10px;\n}\n\n\n@media (max-width: 400px) {\n  .modal-content {\n      width: 90%;\n      padding: 15px;\n  }\n\n  .modal-content h3 {\n      font-size: 18px;\n  }\n}\n\n.dropdown-container {\n  width: 100%;\n  margin: 10px 0;\n  position: relative;\n  font-size: 0.9rem;\n}\n\n.dropdown-header {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  cursor: pointer;\n  transition: border 0.3s ease;\n}\n\n.dropdown-header:hover {\n  border-color: #999;\n}\n\n.dropdown-header:focus, .dropdown-header:active {\n  border-color: #7490c7;\n  outline: none;\n  box-shadow: 0 0 4px rgba(0, 120, 215, 0.2);\n}\n\n.dropdown-menu {\n  position: absolute;\n  width: 100%;\n  top: 110%;\n  left: 0;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  padding: 8px 0;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n\n\n\n/* new dropdown */\n\n.custom-select-container {\n  \n  position: relative;\n  width: 100%;\n  max-width: 220px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.custom-select-header {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n}\n\n.custom-select-header:hover {\n  border-color: #999;\n}\n\n.custom-select-header .arrow {\n  margin-left: 10px;\n  font-size: 12px;\n\n}\n\n.custom-select-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-top: 4px;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 8px 0;\n}\n\n.custom-select-item {\n  display: flex;\n  align-items: flex-start;\n  font-size: 14px;\n  padding: 6px 12px;\n  gap: 8px;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.custom-select-item:hover {\n  background-color: #f1f1f1;\n}\n\n.custom-select-item input {\n  margin-top: 2px;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
